/**
 * @file tokenRefresh.js
 * @description Utility function for refreshing the access token.
 */

import { refreshAccessToken } from "../services/authService";
import { logEvent } from "../services/loggingService";

/**
 * Refreshes the access token.
 * @param {boolean} [forced=false] - Force refresh the token regardless of expiration time
 * @param {string} firstName - The first name of the user, used for the event logging.
 * @param {string} lastName - the last name of the user, used for the event logging.
 * @returns {Promise<string|null>} The new access token, or null if refresh fails.
 */
export const checkAndRefreshToken = async (forced = false, firstName = null, lastName = null) => {
  const currentToken = localStorage.getItem("access_token");
  if (!currentToken) {
    return null;
  }

  try {
    if (forced) {
      const response = await refreshAccessToken(currentToken);
      const newToken = response.access_token;
      localStorage.setItem("access_token", newToken);
      return newToken;
    }

    return currentToken;
  } catch (error) {
    console.error("Failed to refresh token:", error);
    localStorage.removeItem("access_token");
    return null;
  }
};
